import React from 'react'

export const Help = (props:any) => {
	return (<svg width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M6.78747 0C3.53084 0 0.888672 2.64217 0.888672 5.89879C0.888672 8.06988 2.09711 10.0566 3.98144 11.0807V12.3096C3.98144 12.6578 4.24771 12.9241 4.5959 12.9241H8.95855C9.30674 12.9241 9.57301 12.6578 9.57301 12.3096V11.1012C11.4778 10.0771 12.6863 8.06988 12.6863 5.89879C12.6863 2.64217 10.0441 0 6.78747 0ZM8.71277 10.159C8.48747 10.2614 8.34409 10.4867 8.34409 10.712V11.6952H5.21036V10.712C5.21036 10.4663 5.06698 10.2614 4.86217 10.159C3.20313 9.4012 2.11759 7.72168 2.11759 5.89879C2.11759 3.31807 4.20674 1.22892 6.78747 1.22892C9.36819 1.22892 11.4573 3.31807 11.4573 5.89879C11.4573 7.72168 10.3718 9.38072 8.71277 10.159Z" fill="white"/>
	<path d="M8.48711 13.7432H5.08711C4.73892 13.7432 4.47266 14.0094 4.47266 14.3576C4.47266 14.7058 4.73892 14.9721 5.08711 14.9721H8.48711C8.83531 14.9721 9.10157 14.7058 9.10157 14.3576C9.10157 14.0094 8.83531 13.7432 8.48711 13.7432Z" fill="white"/>
	<path d="M7.50425 15.7715H6.07051C5.72232 15.7715 5.45605 16.0377 5.45605 16.3859C5.45605 16.7341 5.72232 17.0004 6.07051 17.0004H7.50425C7.85244 17.0004 8.11871 16.7341 8.11871 16.3859C8.11871 16.0377 7.85244 15.7715 7.50425 15.7715Z" fill="white"/>
	</svg>
	)
}









